// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Feature$ReactHooksTemplate = require("./feature.res.js");
var LlmProvider$ReactHooksTemplate = require("./llmProvider.res.js");
var LlmFeatureRow$ReactHooksTemplate = require("./LlmFeatureRow.res.js");
var LlmFeatureTester$ReactHooksTemplate = require("./LlmFeatureTester.res.js");

function FeatureConfigurations(props) {
  var match = React.useState(function (param) {
        return /* [] */0;
      });
  var setProviders = match[1];
  var providers = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setFeatures = match$1[1];
  var features = match$1[0];
  React.useEffect((function (param) {
          Js_promise.$$catch((function (err) {
                  console.log("Failed to load app features:", err);
                  return Promise.resolve();
                }), Js_promise.then_((function (res) {
                      var decodedProviders = Json_decode.field("llm_providers", (function (param) {
                              return Json_decode.list(LlmProvider$ReactHooksTemplate.fromJson, param);
                            }), res);
                      var decodedFeatures = Json_decode.field("features", (function (param) {
                              return Json_decode.list(Feature$ReactHooksTemplate.fromJson, param);
                            }), res);
                      Curry._1(setProviders, (function (param) {
                              return decodedProviders;
                            }));
                      Curry._1(setFeatures, (function (param) {
                              return decodedFeatures;
                            }));
                      return Promise.resolve();
                    }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/app_features/")));
        }), []);
  var handleFeatureUpdate = function (updatedFeature) {
    Curry._1(setFeatures, (function (prev) {
            return List.map((function (f) {
                          var match = Feature$ReactHooksTemplate.id(f);
                          var match$1 = Feature$ReactHooksTemplate.id(updatedFeature);
                          if (match !== undefined && match$1 !== undefined && match === match$1) {
                            return updatedFeature;
                          } else {
                            return f;
                          }
                        }), prev);
          }));
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx("span", {
                                                            children: "⚙️",
                                                            className: "text-2xl text-indigo-700"
                                                          }),
                                                      className: "flex items-center justify-center w-12 h-12 rounded-2xl bg-indigo-50 shadow"
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("h1", {
                                                              children: "Feature Configurations",
                                                              className: "text-2xl font-bold mb-1 text-gray-900 tracking-tight"
                                                            }),
                                                        JsxRuntime.jsx("p", {
                                                              children: "Configure AI integration settings and behaviors for your features",
                                                              className: "text-sm text-gray-600"
                                                            })
                                                      ]
                                                    })
                                              ],
                                              className: "flex items-center space-x-4"
                                            }),
                                        className: "flex items-center justify-between"
                                      }),
                                  className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                                }),
                            className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(LlmFeatureTester$ReactHooksTemplate.make, {
                                  features: features
                                }),
                            className: "my-10"
                          }),
                      JsxRuntime.jsx("div", {
                            children: $$Array.of_list(List.map((function (feature) {
                                        var id = Feature$ReactHooksTemplate.id(feature);
                                        return JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(LlmFeatureRow$ReactHooksTemplate.make, {
                                                          feature: feature,
                                                          providers: providers,
                                                          onFeatureUpdate: handleFeatureUpdate
                                                        }, id !== undefined ? String(id) : ""),
                                                    className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                                                  });
                                      }), features)),
                            className: "space-y-6"
                          })
                    ],
                    className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
                  }),
              className: "h-full bg-gray-50"
            });
}

var make = FeatureConfigurations;

exports.make = make;
/* react Not a pure module */
